import inviteIcon from '../assets/images/icons/icon-invite.svg';
import whiteLargeLogo from '../assets/images/logo_white_lg.png';
import blackLogo from '../assets/images/logo_black.png';
import whiteSmallLogo from '../assets/images/logo_white_small.png';
import emptyIcon from '../assets/images/empty-icon.png';
import logoutIcon from '../assets/images/icons/icon-logout.svg';
import activismIcon from '../assets/images/icons/icon-activism.svg';
import coffeeIcon from '../assets/images/icons/icon-coffee.svg';
import automotiveIcon from '../assets/images/icons/icon-automotive.svg';
import fitnessIcon from '../assets/images/icons/icon-fitness.svg';
import artIcon from '../assets/images/icons/icon-art.svg';
import comicsIcon from '../assets/images/icons/icon-comics.svg';
import fashionIcon from '../assets/images/icons/icon-fashion.svg';
import foodIcon from '../assets/images/icons/icon-food.svg';
import sneakerIcon from '../assets/images/icons/icon-sneaker.svg';
import astrologyIcon from '../assets/images/icons/icon-astrology.svg';
import beautyIcon from '../assets/images/icons/icon-beauty.svg';
import cannabisIconGray from '../assets/images/icons/cannabis-gray.svg';
import cannabisIcon from '../assets/images/icons/icon-cannabis.svg';
import financeIcon from '../assets/images/icons/icon-finance.svg';
import gameIcon from '../assets/images/icons/icon-game.svg';
import hikingIcon from '../assets/images/icons/icon-hiking.svg';
import movieIcon from '../assets/images/icons/icon-movie.svg';
import renewableIcon from '../assets/images/icons/icon-renewable.svg';
import sportsIcon from '../assets/images/icons/icon-sports.svg';
import technologyIcon from '../assets/images/icons/icon-technology.svg';
import travelIcon from '../assets/images/icons/icon-travel.svg';
import familyIcon from '../assets/images/icons/icon-family.svg';
import otherIcon from '../assets/images/icons/icon-other.svg';
import alcoholIcon from '../assets/images/icons/icon-alcohol.svg';
import coffeeFadeIcon from '../assets/images/icons/icon-line-coffee.svg';
import fashionFadeIcon from '../assets/images/icons/icon-line-clothing.svg';
import automotiveFadeIcon from '../assets/images/icons/icon-line-automotive.svg';
import artFadeIcon from '../assets/images/icons/icon-line-art.svg';
import travelFadeIcon from '../assets/images/icons/icon-line-travel.svg';
import technologyFadeIcon from '../assets/images/icons/icon-line-technology.svg';
import renewableFadeIcon from '../assets/images/icons/icon-line-renewable.svg';
import comicsFadeIcon from '../assets/images/icons/icon-line-comic.svg';
import gamingFadeIcon from '../assets/images/icons/icon-line-game.svg';
import movieFadeIcon from '../assets/images/icons/icon-line-movie.svg';
import spiritualityFadeIcon from '../assets/images/icons/icon-line-astrology.svg';
import hikingFadeIcon from '../assets/images/icons/icon-line-hiking.svg';
import financeFadeIcon from '../assets/images/icons/icon-line-finance.svg';
import sneakersFadeIcon from '../assets/images/icons/icon-line-sneaker.svg';
import activismFadeIcon from '../assets/images/icons/icon-line-activism.svg';
import fitnessFadeIcon from '../assets/images/icons/icon-line-fitness.svg';
import alcoholFadeIcon from '../assets/images/icons/icon-line-alcohol.svg';
import foodFadeIcon from '../assets/images/icons/icon-line-food.svg';
import sportsFadeIcon from '../assets/images/icons/icon-line-sport.svg';
import familyFadeIcon from '../assets/images/icons/icon-line-home.svg';
import cannabisFadeIcon from '../assets/images/icons/icon-line-cannabis.svg';
import beautyFadeIcon from '../assets/images/icons/icon-line-beauty.svg';
import otherActivitiesFadeIcon from '../assets/images/icons/icon-line-other-activities.svg';
import dummyIcon from '../assets/images/dummy-icon.png';
import offerIcon from '../assets/images/icon-offer.png';
import errorIcon from '../assets/images/icons/icon-error-red.svg';
import timeIconRed from '../assets/images/icons/icon-time-red.svg';
import fallbackIcon from '../assets/images/image-fallback.png';
import graphIcon from '../assets/images/icon-graph.svg';
import noRequestIcon from '../assets/images/icon-no-request.svg';
import instaBlackIcon from '../assets/images/icons/icon-insta-black.svg';
import facebookBlackIcon from '../assets/images/icons/icon-facebook-black.svg';
import twitterBlackIcon from '../assets/images/icons/icon-twitter-black.svg';
import spotifyBlackIcon from '../assets/images/icons/icon-spotify-black.svg';
import youtubeBlackIcon from '../assets/images/icons/icon-youtube-black.svg';
import fallbackIconDark from '../assets/images/image-fallback-dark.png';
import userIcon from '../assets/images/user.svg';
import emptyMessageIcon from '../assets/images/empty-icon-message.svg';
import emptyIconMessageFe from '../assets/images/empty-icon-message-fe.svg';
import docIcon from '../assets/images/icons/icon-doc.svg';
import pdfIcon from '../assets/images/icons/icon-pdf.svg';
import xlsIcon from '../assets/images/icons/icon-xls.svg';
import mediaIcon from '../assets/images/icons/icon-media.svg';
import fileIcon from '../assets/images/icons/icon-file.svg';
import cardCoverImage from '../assets/images/login_background.jpg';
import dashboardEmpty from '../assets/images/icons/icon-dashboard-empty.png';

export const LOGO_LARGE_WHITE = whiteLargeLogo;
export const LOGO_SMALL_WHITE = whiteSmallLogo;
export const LOGO_LARGE_BLACK = blackLogo;
export const EMPTY_LOGO = emptyIcon;
export const LOGOUT_ICON = logoutIcon;
export const ACTIVISM_ICON = activismIcon;
export const COFFEE_ICON = coffeeIcon;
export const AUTOMOTIVE_ICON = automotiveIcon;
export const FITNESS_ICON = fitnessIcon;
export const ART_ICON = artIcon;
export const COMICS_ICON = comicsIcon;
export const FASHION_ICON = fashionIcon;
export const FOOD_ICON = foodIcon;
export const SNEAKER_ICON = sneakerIcon;
export const ASTROLOGY_ICON = astrologyIcon;
export const BEAUTY_ICON = beautyIcon;
export const CANNABIS_ICON = cannabisIcon;
export const CANNABIS_ICON_GRAY = cannabisIconGray;
export const FINANCE_ICON = financeIcon;
export const GAME_ICON = gameIcon;
export const HIKING_ICON = hikingIcon;
export const MOVIE_ICON = movieIcon;
export const RENEWABLE_ICON = renewableIcon;
export const SPORTS_ICON = sportsIcon;
export const TECHNOLOGY_ICON = technologyIcon;
export const TRAVEL_ICON = travelIcon;
export const FAMILY_ICON = familyIcon;
export const OTHER_ICON = otherIcon;
export const ALCOHOL_ICON = alcoholIcon;
export const COFFEE_FADE_ICON = coffeeFadeIcon;
export const FASHION_FADE_ICON = fashionFadeIcon;
export const AUTOMOTIVE_FADE_ICON = automotiveFadeIcon;
export const ART_FADE_ICON = artFadeIcon;
export const TRAVEL_FADE_ICON = travelFadeIcon;
export const TECHNOLOGY_FADE_ICON = technologyFadeIcon;
export const RENEWABLE_FADE_ICON = renewableFadeIcon;
export const COMICS_FADE_ICON = comicsFadeIcon;
export const GAMING_FADE_ICON = gamingFadeIcon;
export const MOVIE_FADE_ICON = movieFadeIcon;
export const SPIRITUALITY_FADE_ICON = spiritualityFadeIcon;
export const HIKING_FADE_ICON = hikingFadeIcon;
export const FINANCE_FADE_ICON = financeFadeIcon;
export const SNEAKERS_FADE_ICON = sneakersFadeIcon;
export const ACTIVISM_FADE_ICON = activismFadeIcon;
export const FITNESS_FADE_ICON = fitnessFadeIcon;
export const ALCOHOL_FADE_ICON = alcoholFadeIcon;
export const FOOD_FADE_ICON = foodFadeIcon;
export const SPORTS_FADE_ICON = sportsFadeIcon;
export const FAMILY_FADE_ICON = familyFadeIcon;
export const CANNABIS_FADE_ICON = cannabisFadeIcon;
export const BEAUTY_FADE_ICON = beautyFadeIcon;
export const OTHER_ACTIVITIES_FADE_ICON = otherActivitiesFadeIcon;
export const DUMMY_ICON = dummyIcon;
export const INVITE_ICON = inviteIcon;
export const OFFER_ICON = offerIcon;
export const ERROR_ICON = errorIcon;
export const TIME_ICON_RED = timeIconRed;
export const FALLBACK_ICON = fallbackIcon;
export const NO_REQUEST_ICON = noRequestIcon;
export const INSTA_BLACK_ICON = instaBlackIcon;
export const FACEBOOK_BLACK_ICON = facebookBlackIcon;
export const TWITTER_BLACK_ICON = twitterBlackIcon;
export const SPOTIFY_BLACK_ICON = spotifyBlackIcon;
export const YOUTUBE_BLACK_ICON = youtubeBlackIcon;
export const USER_ICON = userIcon;
export const GRAPH_ICON = graphIcon;
export const FALLBACK_DARK_ICON = fallbackIconDark;
export const EMPTY_MESSAGE_ICON = emptyMessageIcon;
export const EMPTY_MESSAGE_ICON_FE = emptyIconMessageFe;
export const DOC_ICON = docIcon;
export const PDF_ICON = pdfIcon;
export const XLS_ICON = xlsIcon;
export const MEDIA_ICON = mediaIcon;
export const FILE_ICON = fileIcon;
export const CARD_COVER = cardCoverImage;
export const DASHBOARD_EMPTY = dashboardEmpty;

export const ICON_TYPE = {
  Alcohol: ALCOHOL_FADE_ICON,
  Fashion: FASHION_FADE_ICON,
  Automotive: AUTOMOTIVE_FADE_ICON,
  'Food/Drink': FOOD_FADE_ICON,
  'Health/Beauty/Fitness': BEAUTY_FADE_ICON,
  'Tech/Entertainment': TECHNOLOGY_FADE_ICON,
  Travel: TRAVEL_FADE_ICON,
  Finance: FINANCE_FADE_ICON,
  Other: COFFEE_FADE_ICON,
  'Cannabis/CBD/Brands': CANNABIS_ICON_GRAY,
};
